import React from 'react';
import {useState, useEffect} from 'react';
import hoc from './FieldHOC';

let zxcvbn = null;

const PasswordField = function (props) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [barWidth, setBarWidth] = useState(0);
  const [color, setColor] = useState('');
  const [strength, setStrength] = useState('');

  useEffect(() => {
    if (zxcvbn === null){
      require(/* webpackPrefetch: true */ ['zxcvbn'], (module) => {
        zxcvbn = module;
      });
    }
  }, []);

  const confirmChanged = (e) => {
    setConfirm(e.target.value);
  }

  const passwordChanged = (e) => {
    let value = e.target.value;
    let test = zxcvbn ? zxcvbn(value) : {score: 2},
      strength,
      width = (test.score === 0 ? 5 : test.score * 17.5) + '%',
      color;

    if (test.score === 4){
      width = 'calc(100% - 80px)';
    }

    switch (test.score){
      case 0:
        color = '#FF0A00';
        strength = 'Very Weak';
        break;
      case 1:
        color = '#FF0A00';
        strength = 'Weak';
        break;
      case 2:
        color = '#FFAA00';
        strength = 'Okay';
        break;
      case 3:
        color = '#daff00';
        strength = 'Strong';
        break;
      case 4:
        color = '#3cff00';
        strength = 'Very Strong';
        break;
    }
    props.onChange(value);
    setBarWidth(width);
    setPassword(value);
    setColor(color);
    setStrength(strength);
  }

  const formClass = 'form-group ' + (props.error ? 'has-error' : '');

  return <div className={formClass}>
    <div style={{width: '49%', marginRight: '1%', display: 'inline-block'}}>
      <label>Password Field</label>
      <input type="password" name={props.name} tabIndex={props.tabIndex} className="form-control" value={password} onChange={passwordChanged} />
    </div>
    <div style={{width: '49%', display: 'inline-block'}}>
      <label>Confirm Password</label>
      <input type="password" name={props.name + '-confirm'} tabIndex={props.tabIndex} className="form-control" value={confirm} onChange={confirmChanged} />
    </div>
    {props.error ? <span className="help-block">
      {props.error}
    </span> : null}
    <div style={{opacity: 0.5, marginTop: 0}}>
      <div style={{display: 'inline-block', background: color, width: barWidth, height: 5, transitionDuration: '500ms'}} /><span style={{textAlign: 'center', display: 'inline-block', position: 'relative', top: 2, left: 5, fontSize: '0.9em'}}>{strength}</span>
    </div>
  </div>;
}

export default hoc(PasswordField);
